import PropTypes from 'prop-types'
import i18n from 'core/common/i18n'
import Modal from 'core/components/Modal'
import Typography from 'core/components/Typography'

const ProductDialogPriceEditInPromotion = ({ handler }) => {
  const { isOpen, onClose, onConfirm } = handler
  return (
    <Modal
      open={isOpen()}
      fullWidth
      maxWidth="xs"
      aria-labelledby="form-dialog-title"
      title={i18n.t('ProductDialogPriceEditInPromotion.title')}
      textCancel={i18n.t('ProductDialogPriceEditInPromotion.cancel')}
      textConfirm={i18n.t('ProductDialogPriceEditInPromotion.confirm')}
      onCancel={onClose}
      onAbort={onClose}
      onConfirm={onConfirm}
    >
      <Typography>{i18n.t('ProductDialogPriceEditInPromotion.description')}</Typography>
    </Modal>
  )
}

ProductDialogPriceEditInPromotion.propTypes = {
  handler: PropTypes.object.isRequired,
}

export default ProductDialogPriceEditInPromotion
